require('../bootstrap');
require('../directives');
require('../filters');
require('./components');

import Gtag from '../src/core/Gtag';
import Media from '../src/mixins/Media';

new Vue({
  el: '#app',
  mixins: [Media],
  data: {
    search: {
      opened: false,
    },
  },
  mounted() {
    window.addEventListener('click', event =>
      window.EventHandler.fire('body-clicked', event)
    );
    new Gtag();
  },
  methods: {
    backgroundImage(paths) {
      return {
        backgroundImage: "url('" + paths[this.media] + "')",
      };
    },
  },
});
